import { render } from "./TappableItem.vue?vue&type=template&id=50f1f266&scoped=true"
import script from "./TappableItem.vue?vue&type=script&lang=ts"
export * from "./TappableItem.vue?vue&type=script&lang=ts"

import "./TappableItem.vue?vue&type=style&index=0&id=50f1f266&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50f1f266"

export default script